// ** React Imports
import { useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'

// ** Custom Components
import CustomChip from 'src/materio/@core/components/mui/chip'

// ** Types
import { ThemeColor } from 'src/materio/@core/layouts/types'

import { MissingData, LeadScreenStore, ViewType, Lead } from "src/stores/LeadStore";
import { red } from '@mui/material/colors'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import ThreeDRotation from '@mui/icons-material/ThreeDRotation';
import { inherits } from 'util'
import Link from '@mui/material/Link';


interface Props {
    labelText: string,
    valueText: string | undefined,
    textColor: string,
    errorText: string,
    chipHeight: number
    chipFontSize: string,
    chipfontWeight: number,
    isChip: boolean,
    leadId: string,
    lead: Lead
}

const LeadCompanyComponent = ({ labelText, valueText, textColor, errorText, chipHeight, chipFontSize, chipfontWeight, isChip, leadId, lead }: Props) => {
    const getName = () => {
        return valueText && valueText != '' ? valueText : ''
    }

    const onLinkClick = () => {
        LeadScreenStore.update(s => { s.selectedView = ViewType.ViewCompany; s.selectedLead = lead });
    }

    return (
        <Grid sx={{ display: 'flex', alignItems: 'center' }} spacing={12}>
            <Typography sx={{ mr: 2, fontWeight: 500, fontSize: '0.875rem' }}>{labelText}</Typography>

            {!valueText && valueText == '' &&
                <CustomChip
                    skin='light'
                    size='small'
                    label={errorText}
                    sx={{
                        height: { chipHeight },
                        fontSize: { chipFontSize },
                        fontWeight: { chipfontWeight },
                        borderRadius: '5px',
                        textTransform: 'capitalize',
                        color: 'dimgrey',
                        alignItems: 'center'
                    }}
                />}
            {valueText && valueText != '' && isChip &&
                <CustomChip
                    skin='light'
                    size='small'
                    label={getName()}
                    sx={{
                        height: chipHeight,
                        fontSize: chipFontSize,
                        fontWeight: chipfontWeight,
                        borderRadius: '5px',
                        textTransform: 'capitalize',
                        color: textColor,
                        alignItems: 'center',
                        alignContent: 'center',
                        textAlign: 'justify'
                    }}
                />}
            {valueText && valueText != '' && !isChip &&
                <Link
                    sx={{ color: textColor }}
                    underline="hover"
                    component="button"
                    variant="body2"
                    onClick={onLinkClick}
                >
                    {valueText} 
                </Link>

            }


        </Grid>
    )

}

export { LeadCompanyComponent }
export default LeadCompanyComponent